<template>
  <div>
    <div class="pb-12">
      <div class="flex border-b border-dark-b">
        <h2 class="text-xl md:text-2xl font-medium">Credit Cards</h2>
      </div>
      <CardPayment :cards="cards" @fetchCards="fetchCards" />
    </div>
    <div>
      <div class="flex border-b border-dark-b">
        <h2 class="text-xl md:text-2xl font-medium mr-6">
          Bank Accounts for ACH/Wire Transfer
        </h2>
      </div>
      <AccountPayment
        :achs="achs"
        @fetchAchs="fetchAchs"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import CardPayment from '@/shared/components/profile/payment/CardPayment'
import AccountPayment from '@/shared/components/profile/payment/AccountPayment'

export default {
  name: 'PaymentMethods',
  components: {
    CardPayment,
    AccountPayment
  },
  data() {
    return {
      tab: 'card',
      cards: [],
      achs: []
    }
  },
  async created() {
    this.cards = await this.fetchBuyerCards()
    this.achs = await this.fetchBuyerACH()
  },
  methods: {
    ...mapActions ([
      'fetchBuyerCards',
      'fetchBuyerACH'
    ]),
    async fetchCards() {
      this.cards = await this.fetchBuyerCards()
    },
    async fetchAchs() {
      this.achs = await this.fetchBuyerACH()
    }
  }
}
</script>
